import React, { useEffect } from 'react';
import axios from 'axios';
import userManager, { signoutRedirect } from '../../services/users/identity/user.service';
import LoadingPage from '../../components/Layout/LoadingPage/LoadingPage.component';
import { revokeUserToken } from '../../services/users/users.service';

const REVOKE_EXPIRY_SAFETY_WINDOW_SECONDS = 5;

const isRevokeTokenSafe = async (): Promise<void> => {
  try {
    const user = await userManager.getUser();
    const nowSeconds = Math.floor(Date.now() / 1000);
    const expiresAt = user?.expires_at;
    const hasSafeTimeToRevoke =
      typeof expiresAt === 'number' && expiresAt - nowSeconds > REVOKE_EXPIRY_SAFETY_WINDOW_SECONDS;

    if (!user?.access_token || !hasSafeTimeToRevoke) {
      console.warn('Skipping revoke because token is missing, expired, or too close to expiry');
      return;
    }

    await revokeUserToken();
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      console.warn('Skipping revoke because token already expired');
      return;
    }

    console.error('Failed to revoke user token:', error);
  }
};

export const signoutAsync = async (isTokenNotExpired?: boolean): Promise<void> => {
  if (isTokenNotExpired) {
    await isRevokeTokenSafe();
    await signoutRedirect();
  } else {
    try {
      await userManager.removeUser();
      localStorage.clear();
      sessionStorage.clear();
      await userManager.signinRedirect({
        prompt: 'login',
      });
    } catch (error) {
      console.error('Error during token expiry logout:', error);
      window.location.href = '/login';
    }
  }
};

export const SignoutOidc: React.FC = () => {
  useEffect(() => {
    signoutAsync(true);
  }, []);

  return <LoadingPage />;
};

export default SignoutOidc;
